if (!customElements.get('lc-hero-slider')) {
  customElements.define('lc-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.index = 0;
      this.timer = null;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.addEventListener('click', (e) => {
        const button = e.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-next')) this.show(this.index + 1, true);
        if (button.hasAttribute('data-prev')) this.show(this.index - 1, true);
        if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go), true);
        if (button.hasAttribute('data-pause')) { this.playing = !this.playing; this.syncPause(); this.schedule(); }
      }, opts);
      this.addEventListener('keydown', (e) => {
        if (!e.target.closest('.lc-slide-controls')) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, opts);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, opts);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, opts);
      this.addEventListener('focusin', () => this.stop(), opts);
      this.addEventListener('focusout', () => setTimeout(() => this.schedule(), 0), opts);
      this.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        this.touch = { x: e.touches[0].clientX, y: e.touches[0].clientY }; this.stop();
      }, { ...opts, passive: true });
      this.addEventListener('touchend', (e) => {
        if (!this.touch || !e.changedTouches.length) return;
        const dx = e.changedTouches[0].clientX - this.touch.x;
        const dy = e.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) this.show(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null; this.schedule();
      }, { ...opts, passive: true });
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.findIndex(s => s.dataset.blockId === e.detail.blockId);
        if (i < 0) return;
        this.playing = false; this.syncPause(); this.show(i, true);
      }, opts);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.playing = false;
        this.syncPause(); this.schedule();
      }, opts);
      this.setAttribute('data-ready', 'true');
      this.show(0); this.syncPause();
    }
    disconnectedCallback() { this.stop(); this.controller?.abort(); }
    stop() { clearTimeout(this.timer); this.timer = null; }
    schedule() {
      this.stop();
      if (!this.isConnected || this.slides.length < 2 || !this.playing || this.hovered || this.contains(document.activeElement) || document.hidden || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    syncPause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.textContent = this.playing ? (document.documentElement.lang === 'ar' ? 'إيقاف مؤقت' : 'Pause') : (document.documentElement.lang === 'ar' ? 'تشغيل' : 'Play');
      button.setAttribute('aria-label', this.playing ? (document.documentElement.lang === 'ar' ? 'إيقاف عرض الشرائح مؤقتًا' : 'Pause slideshow') : (document.documentElement.lang === 'ar' ? 'تشغيل عرض الشرائح' : 'Play slideshow'));
    }
    show(index, manual = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      const status = this.querySelector('[data-slide-status]');
      if (manual && status) status.textContent = document.documentElement.lang === 'ar' ? `العرض ${this.index + 1} من ${this.slides.length}` : `Offer ${this.index + 1} of ${this.slides.length}`;
      this.schedule();
    }
  });
}
